import { render } from "./HeroiconsSolidDocumentSearch.vue?vue&type=template&id=58c3dec2"
const script = {}

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDocumentSearch.vue"]])

export default __exports__